import { RadioGroupProps, RadioGroup, Spacing } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { WorkspaceTypeSpecification } from 'zens-store'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  group: {
    flexWrap: 'wrap',
    marginHorizontal: -Spacing.M,
    maxWidth: undefined,
  },
  specification: {
    marginLeft: Spacing.M,
    marginRight: Spacing.M,
  },
})

interface Props extends Omit<RadioGroupProps<WorkspaceTypeSpecification>, 'items'> {
  onChange?: (value: 'portrait' | 'landscape') => void
}
const Orientation = (props: Props) => {
  const { style, optionStyle, ...otherProps } = props
  const { t } = useTranslation()

  const items = [
    {
      value: 'portrait',
      title: t('Portrait'),
    },
    {
      value: 'landscape',
      title: t('Landscape'),
    },
  ]

  return (
    <RadioGroup
      items={items}
      style={[style, styles.group]}
      optionStyle={[optionStyle, styles.specification]}
      onSelect={(value) => props.onChange?.(value)}
      {...otherProps}
    />
  )
}

export default Orientation
